// extracted by mini-css-extract-plugin
export default {"container":"UiTour_container","header":"UiTour_header","headerButton":"UiTour_headerButton","imageContainer":"UiTour_imageContainer","headerImage":"UiTour_headerImage"};